/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("DialogController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class DialogController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class DialogController extends cls.ControllerBase /** @lends classes.DialogController.prototype */ {
    static __name = "DialogController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // pseudo-selector behaviors
      this._addBehavior(cls.ActivePseudoSelectorBehavior);
      // 4st behaviors
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      this._addBehavior(cls.MenuEnabledVMBehavior);
      this._addBehavior(cls.ColorVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontWeightVMBehavior);
      this._addBehavior(cls.TextDecorationVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);

      // 4ST styles
      this._addBehavior(cls.ActionPanelPosition4STBehavior);
      this._addBehavior(cls.ActionPanelButtonTextAlign4STBehavior);
      this._addBehavior(cls.ActionPanelButtonTextHidden4STBehavior);
    }

    /**
     * @inheritDoc
     */
    attachUI() {
      if (!this._widget || this.isInChromeBar()) {
        return;
      }
      const anchorNode = this.getAnchorNode(),
        windowNode = anchorNode && anchorNode.getAncestor("Window"),
        windowController = windowNode && windowNode.getController(),
        windowWidget = windowController && windowController.getWidget();

      if (windowWidget && windowWidget.addMenu) {
        windowWidget.addMenu(this._widget);
      }
    }
  }

  cls.DialogController = DialogController;
  cls.ControllerFactory.register("Dialog", cls.DialogController);
});
